<template>
  <div>
    <ConfirmDelete :visible="deleteConfirm.visible"
                   :type="deleteConfirm.type"
                   :deleteProducts.sync="deleteConfirm.deleteProducts"
                   @close="closeDeleteConfirm"
                   @confirm="confirmDeleteTarget"/>

    <div class="gss-top-bar">
      <div class="gss-hint title">
        Você pode <b>adicionar</b> , <b>editar</b> grupos/subgrupos e <b>arrastar para ordenar</b>
      </div>
    </div>

    <ScrollBar :maxHeight="400"
               :minHeight="400">
      <div class="draggable-wrap">
        <div v-if="isTwoLevels"
             class="draggable-toolbar">
          <button class="draggable-add-btn"
                  @click="addGroup">
            <i class="fa-solid fa-plus"></i> <span>Grupo</span>
          </button>

          <button v-if="isSubGroup"
                  class="draggable-add-btn"
                  @click="toggleAll">
            <i :class="allCollapsed ? 'fa-chevron-right' : 'fa-chevron-down'"
               class="fa-solid"></i> <span>
              {{ allCollapsed ? 'Expandir subgrupos' : 'Recolher subgrupos' }}
            </span>
          </button>

          <Button v-if="templateMode"
                  :clicked="importFromRental"
                  _key="btnImportFromRental"
                  backGroundColor="#009183"
                  classIcon="fa-solid fa-file-import"
                  color="white"
                  size="small"
                  title="Importar da Locação"/>
        </div>

        <div v-if="groups.length === 0"
             class="draggable-no-data">
          Nenhum registro encontrado!
        </div>

        <template v-if="isTwoLevels">
          <draggable v-model="groups"
                     :disabled="isEditing"
                     group="groups"
                     handle=".draggable-drag-handle"
                     @end="onDragEndGroups">
            <div v-for="group in groups"
                 :key="group.id"
                 class="draggable-group">
              <div :class="{ 'no-border': !showGroups }"
                   class="draggable-group-header">
                <div class="draggable-group-left">
                  <i class="fa-solid fa-grip-vertical draggable-drag-handle"></i>

                  <template v-if="group.editing">
                    <div class="input-with-icon">
                      <input v-model="group.name"
                             class="draggable-edit-input"
                             type="text"
                             @keydown.enter.prevent="finishGroupEdit(group)"
                             @keydown.esc.prevent="finishGroupEdit(group)"
                             @blur="finishGroupEdit(group)"/> <i class="fa-solid fa-check input-check"
                                                                 @click.stop="finishGroupEdit(group)"></i>
                    </div>
                  </template>
                  <template v-else>
                    <div class="draggable-editable-wrap"
                         @dblclick.stop="editGroup(group)">
                      <span class="draggable-group-name">{{ group.name }}</span>
                      <i class="fa-solid fa-pen-to-square draggable-edit-icon"
                         title="Editar"
                         @click.stop="editGroup(group)"></i>
                    </div>
                  </template>
                </div>

                <div class="draggable-group-actions">
                  <button v-if="group.name !== 'Sem grupo'"
                          :title="group.collapsed ? 'Expandir subgrupos' : 'Recolher subgrupos'"
                          class="draggable-btn-arrow"
                          @click.stop="toggleGroup(group)">
                    <i :class="group.collapsed ? 'fa-chevron-right' : 'fa-chevron-down'"
                       class="fa-solid"></i>
                  </button>

                  <button v-if="group.name !== 'Sem grupo'"
                          class="draggable-add-sub-btn draggable-add-sub-inline"
                          title="Adicionar subgrupo"
                          @click.stop="addSubgroup(group)">
                    <i class="fa-solid fa-plus"></i> <span>Subgrupo</span>
                  </button>

                  <button class="draggable-del-btn"
                          @click.stop="askRemoveGroup(group)">
                    <i class="fa-solid fa-trash-can"></i>
                  </button>
                </div>
              </div>

              <div v-if="!group.collapsed"
                   class="draggable-subgroups">

                <draggable v-model="group.subgroups"
                           :disabled="isEditing"
                           group="subgroups"
                           handle=".draggable-drag-handle"
                           @end="onDragEndSubs">
                  <div v-for="sub in group.subgroups"
                       :key="sub.id"
                       class="draggable-subgroup">
                    <div class="draggable-subgroup-line">
                      <div class="draggable-subgroup-left">
                        <i class="fa-solid fa-grip-vertical draggable-drag-handle"></i>
                        <i class="fa-regular fa-layer-group draggable-icon-subgroup"></i>

                        <template v-if="sub.editing">
                          <div class="input-with-icon">
                            <input v-model="sub.name"
                                   class="draggable-edit-input"
                                   type="text"
                                   @keydown.enter.prevent="finishSubgroupEdit(sub)"
                                   @keydown.esc.prevent="finishSubgroupEdit(sub)"
                                   @blur="finishSubgroupEdit(sub)"/> <i class="fa-solid fa-check input-check"
                                                                        @click.stop="finishSubgroupEdit(sub)"></i>
                          </div>
                        </template>
                        <template v-else>
                          <div class="draggable-editable-wrap"
                               @dblclick.stop="editSubgroup(sub)">
                            <span class="draggable-editable-title">{{ sub.name }}</span>
                            <i class="fa-solid fa-pen-to-square draggable-edit-icon"
                               title="Editar"
                               @click.stop="editSubgroup(sub)"></i>
                          </div>
                        </template>

                        <span v-if="(sub.products || []).length > 0"
                              class="draggable-badge">
                          {{ (sub.products || []).length }}
                        </span>
                      </div>

                      <div class="draggable-subgroup-actions">
                        <button class="draggable-del-btn"
                                @click.stop="askRemoveSubgroup(group, sub)">
                          <i class="fa-solid fa-trash-can"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </draggable>

                <div v-if="group.subgroups.length === 0"
                     class="draggable-no-subgroups">
                  Nenhum subgrupo. Clique em <b>Subgrupo</b> para adicionar.
                </div>
              </div>
            </div>
          </draggable>
        </template>

        <template v-else>
          <draggable v-model="groups"
                     :disabled="isEditing"
                     group="groups"
                     handle=".draggable-drag-handle"
                     @end="onDragEndGroups">
            <div v-for="group in groups"
                 :key="group.id"
                 class="draggable-group-single">
              <div class="draggable-group-header">
                <i class="fa-solid fa-grip-vertical draggable-drag-handle"></i>

                <span class="draggable-group-name">
                  {{ group.name }}
                </span>

                <button class="draggable-del-btn"
                        @click.stop="askRemoveGroup(group)">
                  <i class="fa-solid fa-trash-can"></i>
                </button>
              </div>
            </div>
          </draggable>
        </template>
      </div>
    </ScrollBar>

    <div class="draggable-footer">
      <Button v-if="!templateMode"
              :clicked="confirmCreateEditOrder"
              :disabled="groups.length === 0"
              _key="btnOk"
              backGroundColor="#009183"
              classIcon="fa-solid fa-floppy-disk"
              color="white"
              size="large"
              title="Salvar"/>
      <Button v-else
              :clicked="openSaveTemplate"
              :disabled="groups.length === 0"
              _key="btnSaveTemplate"
              backGroundColor="#009183"
              classIcon="fa-solid fa-floppy-disk"
              color="white"
              size="large"
              :title="isTemplateEditing ? 'Atualizar modelo' : 'Salvar modelo'"/>
    </div>

    <transition name="fade">
      <div v-if="showSaveTemplatePrompt"
           class="template-prompt-backdrop">
        <div class="template-prompt-card">
          <div class="template-prompt-header">
            <h4>{{ templatePromptTitle }}</h4>
            <button class="template-prompt-close"
                    @click="cancelSaveTemplatePrompt">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
          <div class="template-prompt-body">
            <input v-model="templateTitle"
                   class="template-prompt-input"
                   type="text"
                   :placeholder="templatePromptPlaceholder"
                   @keydown.enter.prevent="saveTemplateLocal"
                   @keydown.esc.prevent="cancelSaveTemplatePrompt"/>
          </div>
          <div class="template-prompt-actions">
            <button class="template-btn-cancel"
                    @click="cancelSaveTemplatePrompt">Cancelar
            </button>
            <Button :clicked="saveTemplateLocal"
                    :disabled="!canConfirmTemplateName"
                    _key="btnSaveTemplateConfirm"
                    backGroundColor="#009183"
                    color="white"
                    size="large"
                    :title="saveTemplateConfirmButton"/>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Button from '@nixweb/nixloc-ui/src/component/forms/Button'
import ScrollBar from '@nixweb/nixloc-ui/src/component/layout/ScrollBar.vue'
import ConfirmDelete from './items-rent/ConfirmDelete.vue'

import draggable from 'vuedraggable'
import {mapActions, mapMutations} from 'vuex'

export default {
  name: 'GroupDraggable',
  components: {
    Button,
    ConfirmDelete,
    ScrollBar,
    draggable,
  },
  props: {
    levels: {type: Number, default: 2},
    items: {type: Array, default: () => []},
    operational: {type: Boolean, default: false},
    migrate: {type: Boolean, default: false},
    templateMode: {type: Boolean, default: false},
    templateEditing: {
      type: Object,
      default: () => null,
    },
    selectedPeriod: Object,
    loadingCreateEditOrder: {
      type: Boolean,
      default: true,
    },
    onChanged: Function,
  },
  data() {
    return {
      rentId: this.$route?.params?.id,
      urlGetAll: '/api/v1/rental/group-subgroup-rent/get-all',
      urlCreateEditOrder: '/api/v1/rental/group-subgroup-rent/create-edit-order',
      urlDeleteGroup: '/api/v1/rental/group-subgroup-rent/delete-group',
      urlDeleteSubgroup: '/api/v1/rental/group-subgroup-rent/delete-subgroup',
      itemsLocal: [],
      groups: [],
      showGroups: true,
      allCollapsed: false,
      loadingMigrate: false,
      idSeed: 1000,
      showSaveTemplatePrompt: false,
      templateTitle: '',
      loading: false,
      deleteConfirm: {
        visible: false,
        type: null,
        group: null,
        groupIndex: null,
        subgroup: null,
        subgroupIndex: null,
        deleteProducts: false,
      },
    }
  },
  created() {
    this.itemsLocal = JSON.parse(JSON.stringify(this.items || []))
    this.buildData()

    if (this.migrate) {
      this.loadingMigrate = true
      this.createEditOrder()
    }
  },
  computed: {
    isTwoLevels() {
      return Number(this.levels) === 2
    },
    isEditing() {
      return this.groups.some((g) => g.editing || (Array.isArray(g.subgroups) && g.subgroups.some((s) => s.editing)))
    },
    isSubGroup() {
      return this.groups.some((g) => Array.isArray(g.subgroups) && g.subgroups.length > 0)
    },
    isTemplateEditing() {
      return !!(this.templateMode && this.templateEditing?.id)
    },
    templatePromptTitle() {
      return this.isTemplateEditing ? 'Atualizar modelo' : 'Salvar modelo'
    },
    templatePromptPlaceholder() {
      return this.isTemplateEditing ? 'Digite o novo nome do modelo' : 'Digite o nome do modelo'
    },
    canConfirmTemplateName() {
      return !!(this.templateTitle || '').trim()
    },
    saveTemplateConfirmButton() {
      return this.isTemplateEditing ? 'Atualizar modelo' : 'Salvar modelo'
    },
  },
  methods: {
    ...mapActions('generic', ['getApi', 'deleteApi', 'putApi', 'postApi']),
    ...mapMutations('generic', ['addEvent', 'hideModal', 'removeLoading']),
    buildData() {
      this.groups = this.buildNestedTwoLevels(this.itemsLocal)
      this.recalcOrders()
    },
    buildNestedTwoLevels(list) {
      const data = []
      ;(list || []).forEach((group) => {
        const g = {
              id: group.groupId,
              name: (group.groupName ?? '').trim(),
              order: group.groupOrder ?? null,
              editing: false,
              collapsed: false,
              subgroups: [],
            }
        ;(group.subGroups || []).forEach((sub) => {
          g.subgroups.push({
            id: sub.groupId,
            name: (sub.groupName ?? '').trim(),
            order: sub.groupOrder ?? null,
            editing: false,
            products: Array.isArray(sub.products) ? sub.products : [],
          })
        })
        data.push(g)
      })
      return data
    },
    recalcOrders() {
      this.groups.forEach((g, gi) => {
        this.$set(g, 'order', gi + 1)
        if (Array.isArray(g.subgroups)) {
          g.subgroups.forEach((s, si) => {
            this.$set(s, 'order', si + 1)
          })
        }
      })
    },
    nextSequentialName(list, baseName) {
      const rx = new RegExp(`^${baseName}\\s+(\\d+)$`, 'i')
      let max = 0
      ;(list || []).forEach((it) => {
        const name = (it && it.name ? String(it.name) : '').trim()
        const m = name.match(rx)
        if (m) {
          const n = parseInt(m[1], 10)
          if (!isNaN(n) && n > max) max = n
        }
      })
      return `${baseName} ${max + 1}`
    },
    async getAll() {
      const response = await this.getApi({
        url: this.urlGetAll,
        obj: {
          any: this.rentId,
          id: this.selectedPeriod.period.id,
        },
      })
      this.groups = this.buildNestedTwoLevels(response.content.data)
      if (this.allCollapsed) {
        this.groups.forEach((g) => this.$set(g, 'collapsed', true))
      }
      this.loadingMigrate = false
      this.loading = false
      return response
    },
    async getAllForImportWithoutIds() {
      const response = await this.getApi({
        url: this.urlGetAll,
        obj: {
          any: this.rentId,
          id: this.selectedPeriod.period.id,
        },
      })

      const importedGroups = this.buildNestedTwoLevels(response?.content?.data || [])
      this.groups = importedGroups.map((group) => ({
        ...group,
        id: this.nextId(),
        subgroups: (group.subgroups || []).map((sub) => ({
          ...sub,
          id: this.nextId(),
        })),
      }))

      if (this.allCollapsed) {
        this.groups.forEach((g) => this.$set(g, 'collapsed', true))
      }

      this.recalcOrders()
      return response
    },
    async createEditOrder() {
      this.loading = true
      const response = await this.putApi({
        url: this.urlCreateEditOrder,
        obj: {
          periodRentId: this.selectedPeriod.period.id,
          rentId: this.rentId,
          onlyStock: this.operational,
          groups: this.groups,
        },
        notNotifyToast: true,
      })
      if (typeof this.onChanged === 'function') this.onChanged()
      this.removeLoading(['btnOk'])
      return response
    },
    async deleteGroup(id, deleteSubgroups = false) {
      if (this.templateMode) {
        return {success: true}
      }
      const response = await this.deleteApi({
        url: `${this.urlDeleteGroup}?id=${id}${
            deleteSubgroups ? '&deleteSubgroups=true' : ''
        }&operational=${this.operational}`,
        notNotifyToast: true,
      })
      this.removeLoading(['btnDelete'])
      return response
    },
    async deleteSubgroup(id, deleteProducts = false) {
      if (this.templateMode) {
        return {success: true}
      }
      const response = await this.deleteApi({
        url: `${this.urlDeleteSubgroup}?id=${id}${
            deleteProducts ? '&deleteProducts=true' : ''
        }&operational=${this.operational}`,
        notNotifyToast: true,
      })
      this.removeLoading(['btnDelete'])
      return response
    },
    nextId() {
      this.idSeed += 1
      return `id_${this.idSeed}`
    },
    addGroup() {
      const newId = this.nextId()
      this.cancelAllEditing()

      const nextName = this.nextSequentialName(this.groups, 'Novo Grupo')

      this.groups.unshift({
        id: newId,
        name: nextName,
        editing: true,
        collapsed: false,
        subgroups: [],
        order: 1,
      })
      this.recalcOrders()
    },
    addSubgroup(group) {
      if (!group.subgroups) this.$set(group, 'subgroups', [])
      const newId = this.nextId()
      this.cancelAllEditing()

      const lastOrder = group.subgroups.length ? group.subgroups[group.subgroups.length - 1].order || 0 : 0

      const nextSubName = this.nextSequentialName(group.subgroups, 'Novo Subgrupo')

      const newSub = {
        id: newId,
        name: nextSubName,
        products: [],
        editing: true,
        order: lastOrder + 1,
      }

      group.subgroups.push(newSub)

      this.recalcOrders()
    },
    addSingleGroup() {
      const newId = this.nextId()
      this.cancelAllEditing()
      this.groups.unshift({
        id: newId,
        name: '',
        editing: true,
        order: 1,
      })
      this.recalcOrders()
    },
    editGroup(group) {
      this.cancelAllEditing()
      this.$set(group, 'editing', true)
    },
    finishGroupEdit(group) {
      const name = (group.name || '').trim()
      if (!name) {
        const idx = this.groups.findIndex((g) => g.id === group.id)
        if (idx > -1) this.groups.splice(idx, 1)
        this.recalcOrders()
        return
      }
      group.name = name
      this.$set(group, 'editing', false)
      this.recalcOrders()
    },
    editSubgroup(sub) {
      this.cancelAllEditing()
      this.$set(sub, 'editing', true)
    },
    finishSubgroupEdit(sub) {
      const name = (sub.name || '').trim()
      if (!name) {
        const group = this.groups.find((g) => Array.isArray(g.subgroups) && g.subgroups.some((s) => s.id === sub.id))
        if (group) {
          const idx = group.subgroups.findIndex((s) => s.id === sub.id)
          if (idx > -1) group.subgroups.splice(idx, 1)
        }
        this.recalcOrders()
        return
      }
      sub.name = name
      this.$set(sub, 'editing', false)
      this.recalcOrders()
    },
    askRemoveGroup(group) {
      const groupIndex = this.groups.findIndex((g) => g.id === group.id)
      this.openDeleteConfirm({
        type: 'group',
        group,
        groupIndex,
      })
    },
    askRemoveSubgroup(group, sub) {
      const groupIndex = this.groups.findIndex((g) => g.id === group.id)
      const subgroupIndex = (group.subgroups || []).findIndex((s) => s.id === sub.id)
      this.openDeleteConfirm({
        type: 'subgroup',
        group,
        groupIndex,
        subgroup: sub,
        subgroupIndex,
      })
    },
    openDeleteConfirm({type, group, groupIndex, subgroup, subgroupIndex}) {
      this.deleteConfirm = {
        visible: true,
        type,
        group: group || null,
        groupIndex: groupIndex ?? null,
        subgroup: subgroup || null,
        subgroupIndex: subgroupIndex ?? null,
        deleteProducts: false,
      }
    },
    closeDeleteConfirm() {
      this.deleteConfirm = {
        visible: false,
        type: null,
        group: null,
        groupIndex: null,
        subgroup: null,
        subgroupIndex: null,
        deleteProducts: false,
      }
    },
    async confirmDeleteTarget() {
      const payload = {...this.deleteConfirm}
      this.closeDeleteConfirm()

      if (payload.type === 'group') {
        const id = payload.group && payload.group.id
        if (!id || String(id).startsWith('id_')) {
          if (payload.groupIndex !== null && payload.groupIndex > -1) {
            this.groups.splice(payload.groupIndex, 1)
            this.recalcOrders()
          }
          return
        }

        const response = await this.deleteGroup(id, payload.deleteProducts === true)
        if (response && response.success) {
          this.groups = this.groups.filter((g) => g.id !== id)
          this.recalcOrders()
        }
        return
      }

      if (payload.type === 'subgroup') {
        const id = payload.subgroup && payload.subgroup.id
        const groupRef =
            this.groups.find((g) => g.id === (payload.group && payload.group.id)) ||
            (payload.groupIndex !== null && payload.groupIndex > -1 ? this.groups[payload.groupIndex] : null)

        if (!groupRef) return

        if (!id || String(id).startsWith('id_')) {
          if (payload.subgroupIndex !== null && payload.subgroupIndex > -1) {
            groupRef.subgroups.splice(payload.subgroupIndex, 1)
            this.recalcOrders()
          }
          return
        }

        const response = await this.deleteSubgroup(id, payload.deleteProducts === true)
        if (response && response.success) {
          groupRef.subgroups = (groupRef.subgroups || []).filter((s) => s.id !== id)
          this.recalcOrders()
        }
      }
    },
    cancelAllEditing() {
      this.groups.forEach((g) => {
        this.$set(g, 'editing', false)
        if (Array.isArray(g.subgroups)) {
          g.subgroups.forEach((s) => this.$set(s, 'editing', false))
        }
      })
    },
    toggleGroup(group) {
      this.$set(group, 'collapsed', !group.collapsed)
    },
    toggleAll() {
      this.allCollapsed = !this.allCollapsed
      const target = this.allCollapsed
      this.groups.forEach((g) => this.$set(g, 'collapsed', target))
    },
    onDragEndGroups() {
      this.recalcOrders()
    },
    onDragEndSubs() {
      this.recalcOrders()
    },
    confirmCreateEditOrder() {
      this.createEditOrder().then(() => {
        this.hideModal()
      })
    },
    openSaveTemplate() {
      this.removeLoading(['btnSaveTemplate'])
      this.templateTitle = this.isTemplateEditing ? this.templateEditing?.name || '' : ''
      this.showSaveTemplatePrompt = true
    },
    cancelSaveTemplatePrompt() {
      this.showSaveTemplatePrompt = false
      this.templateTitle = ''
    },
    async saveTemplateLocal() {
      this.removeLoading(['btnSaveTemplateConfirm'])
      const name = (this.templateTitle || '').trim()
      if (!name || !this.templateMode) return

      const json = JSON.stringify(this.groups || [])
      const params = this.isTemplateEditing
          ? {
            url: '/api/v1/rental/group-template/update',
            obj: {
              id: this.templateEditing.id,
              name,
              json,
            },
          }
          : {
            url: '/api/v1/rental/group-template/create',
            obj: {
              name,
              json,
            },
          }

      const request = this.isTemplateEditing ? this.putApi(params) : this.postApi(params)

      request
          .then((response) => {
            if (response.success) {
              this.cancelSaveTemplatePrompt()
              this.hideModal()
              const responseJson = typeof response.content?.json === 'string' ? response.content.json : json
              this.addEvent({
                name: 'templateSavedFromBuilder',
                data: {
                  id: response.content?.id || this.templateEditing?.id,
                  name: response.content?.name || name,
                  json: responseJson,
                  title: name,
                  template: responseJson,
                  fromEditMode: this.isTemplateEditing,
                },
              })
            }
          })
          .catch((error) => {
            console.error('Erro ao salvar template:', error)
            this.$toasted?.error?.('Erro ao salvar modelo de grupo')
            this.removeLoading(['btnSaveTemplateConfirm'])
          })
    },
    closeModal() {
      this.removeLoading(['btnCancel'])
      this.hideModal()
    },
    backToTemplateList() {
      this.removeLoading(['btnBackTemplateList'])
      this.addEvent({
        name: 'templateBuilderBackToList',
      })
    },
    async importFromRental() {
      try {
        await this.getAllForImportWithoutIds()
        this.$toasted?.success?.('Importada com sucesso')
      } catch (error) {
        this.$toasted?.error?.('Erro ao importar')
      } finally {
        this.removeLoading(['btnImportFromRental'])
      }
    },
  },
  watch: {
    items: {
      handler(newVal) {
        this.itemsLocal = JSON.parse(JSON.stringify(newVal || []))
        this.buildData()
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style scoped>
.draggable-wrap {
  width: 100%;
  box-sizing: border-box;
}

.draggable-toolbar {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 16px;
}

.draggable-add-btn,
.draggable-add-sub-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  border-radius: 9999px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: #2563eb;
  color: #fff;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
}

.draggable-add-btn:hover,
.draggable-add-sub-btn:hover {
  background: #0954f5;
}

.draggable-add-sub-inline {
  background: #009183;
}

.draggable-add-sub-inline:hover {
  background: #007a6e;
}

.draggable-add-sub-btn-padrao {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 50px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: #009183;
  color: #fff;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
}

.draggable-del-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 50px;
  border: 1px solid rgba(239, 68, 68, 0.15);
  background: #ef4444;
  color: #fff;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  margin-left: 8px;
}

.draggable-del-btn:hover {
  background: #dc2626;
}

.draggable-group {
  border: 1px solid #e5e7eb;
  border-radius: 5px;
  background: #fff;
  margin-bottom: 16px;
}

.draggable-group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 16px;
  font-weight: 500;
  border-bottom: 1px solid #fafafc;
}

.draggable-group-header.no-border {
  border-bottom: 0 !important;
}

.draggable-group-left {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.draggable-subgroup {
  padding: 10px 16px;
}

.draggable-subgroup:last-child {
  border-bottom: none;
}

.draggable-subgroup-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-left: 20px;
}

.draggable-subgroup-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.draggable-subgroup-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.draggable-drag-handle {
  cursor: grab;
  color: #9ca3af;
}

.draggable-title-no-group {
  font-size: 13px;
  font-style: italic;
  color: grey;
  font-weight: 500;
}

.draggable-icon-group {
  color: #2563eb;
}

.draggable-icon-subgroup {
  color: #009183;
}

.draggable-no-data {
  border: 1px solid #e5e7eb;
  padding: 20px 0px 20px 10px;
  border-radius: 6px;
  overflow: hidden;
  background: transparent;
  color: #757d8c;
  font-style: italic;
}

.draggable-editable-wrap {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  position: relative;
}

.draggable-editable {
  font-size: 14px;
}

.draggable-edit-icon {
  font-size: 13px;
  margin-left: 6px;
  color: #cbd5e1;
  transition: color 0.2s;
  cursor: pointer;
}

.draggable-add-icon {
  font-size: 13px;
  margin-left: 6px;
  color: #577696;
  transition: color 0.2s;
  cursor: pointer;
  opacity: 0.6;
}

.draggable-editable-wrap:hover .draggable-edit-icon {
  color: #94a3b8;
}

.draggable-edit-input {
  font-size: 14px;
  padding: 4px 26px 4px 6px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  width: 400px;
}

.input-with-icon {
  position: relative;
  display: inline-block;
}

.input-check {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #009183;
  font-size: 14px;
  cursor: pointer;
}

.draggable-editable-title {
  font-size: 13.5px;
}

.draggable-badge {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #e6e7eb;
  padding: 3px 12px;
  border-radius: 999px;
  font-size: 12px;
}

.draggable-btn-arrow {
  margin-right: 10px;
  padding: 8px 5px;
  width: 30px;
  height: 30px;
  border-radius: 50px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: #2563eb;
  color: #fff;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
}

.div-alert-delete {
  margin-top: 10px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.confirm-backdrop {
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  background: rgba(15, 23, 42, 0.45);
  z-index: 9999;
  padding: 20px;
}

.confirm-card {
  width: min(500px, 100%);
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

.confirm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 14px 16px;
}

.confirm-header h4 {
  margin: 0;
  font-size: 1rem;
}

.confirm-close-btn {
  border: 0;
  background: transparent;
  color: #6b7280;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  width: 24px;
  height: 24px;
  line-height: 1;
  border-radius: 999px;
}

.confirm-close-btn:hover {
  background: #f3f4f6;
  color: #111827;
}

.confirm-body {
  padding: 16px;
  color: #334155;
}

.confirm-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 8px 12px;
}

.confirm-save-wrap.is-disabled {
  opacity: 0.5;
  pointer-events: none;
}

.footer-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 8px 4px 0;
}

.footer-actions-btns {
  display: flex;
  gap: 6px;
  align-items: center;
}

.phrase {
  margin-top: 50px;
}

.btn-secondary {
  background: #939394;
  color: #111827;
  border: 0;
  border-radius: 999px;
  padding: 4px 10px;
  width: 80px;
  font-size: 12px;
  line-height: 1.2;
  cursor: pointer;
  color: white;
}

.btn-danger {
  background: #ef4444;
  color: #fff;
  border: 0;
  border-radius: 999px;
  padding: 8px 14px;
  cursor: pointer;
}

.btn-danger:hover {
  background: #dc2626;
}

.gss-top-bar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 15px;
}

.gss-hint {
  margin-top: -10px;
  color: rgb(107, 107, 107);
}

.draggable-subgroup-add-bar {
  padding: 8px 16px 4px;
  border-bottom: 1px solid #f1f5f9;
}

.draggable-no-subgroups {
  padding: 10px 16px;
  font-size: 12px;
  color: #9ca3af;
  font-style: italic;
}

.draggable-group-name {
  font-size: 14px;
  font-weight: 500;
}

.draggable-footer {
  display: flex;
  justify-content: center;
  padding: 16px 0 4px;
}

.template-prompt-backdrop {
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  background: rgba(15, 23, 42, 0.45);
  z-index: 9999;
  padding: 20px;
}

.template-prompt-card {
  width: min(480px, 100%);
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

.template-prompt-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.template-prompt-header h4 {
  margin: 0;
  font-size: 1rem;
}

.template-prompt-close {
  border: 0;
  background: transparent;
  color: #6b7280;
  font-size: 14px;
  cursor: pointer;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.template-prompt-close:hover {
  background: #f3f4f6;
  color: #111827;
}

.template-prompt-body {
  padding: 16px;
}

.template-prompt-input {
  width: 100%;
  font-size: 14px;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  box-sizing: border-box;
  outline: none;
}

.template-prompt-input:focus {
  border-color: #009183;
}

.template-prompt-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 10px 16px 14px;
}

.template-btn-cancel {
  background: #939394;
  color: #fff;
  border: 0;
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 13px;
  cursor: pointer;
}

.template-btn-cancel:hover {
  background: #757576;
}
</style>
